import { render } from "./list1.vue?vue&type=template&id=40bb1912&scoped=true"
import script from "./list1.vue?vue&type=script&lang=js"
export * from "./list1.vue?vue&type=script&lang=js"

import "./list1.vue?vue&type=style&index=0&id=40bb1912&scoped=true&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/kj-wx-web-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40bb1912"]])

export default __exports__